import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { getAbsolutePath, ROUTES } from '../../routes/config';

type AvailablePages = 'products' | 'orders' | 'offers' | 'workers';
type AvailableOption = 'details' | 'edit';

type GeneratePathProps = {
  readonly id?: number;
  readonly page: AvailablePages;
  readonly option: AvailableOption;
  readonly tab?: string;
};

export const useGeneratePath = ({ id, page, option, tab }: GeneratePathProps) =>
  useMemo(() => {
    if (id && tab) {
      return getAbsolutePath(generatePath(ROUTES[page][option].full, { id: id.toString(), tab: tab }));
    } else if (id) {
      return getAbsolutePath(generatePath(ROUTES[page][option].partial, { id: id.toString() }));
    } else {
      return generatePath(ROUTES[page].path);
    }
  }, [id, page, option, tab]);
